import styled from "styled-components";
import { Body } from "@vds/typography";
import {
  APPEARANCE_RUNTIME_STATUS as STATUS,
  STATUS_BADGE_BG_COLORS,
  STATUS_BADGE_TEXT_COLORS,
  IMAGE_STATUS_ICON_BG_COLORS,
  BADGE_COLORS
} from "../../../../constants/enrolledAppearanceConstants";

export const AppearanceListContainer = styled.div``;

export const LazyImageFetchTrigger = styled.div`
  height: 0;
  overflow: hidden;
`;

export const BreadcrumbWrapper = styled.div`
  margin-bottom: 20px;
`;

export const AppearanceListHeader = styled.div`
  display: flex;
  justify-content: start;
  gap: 100px;
  align-items: center;
  margin-bottom: 20px;
`;
export const NotificationWrapper = styled.div`
  margin-top: 24px;
`;

export const PageTitle = styled.div`
  font-family: "Verizon NHG DS";
  font-size: 32px;
  font-weight: 300;
  line-height: 36px;
  letter-spacing: 0.25px;
  text-align: left;
  height: 44px;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 500px;
  width: 100%;
  white-space: nowrap;
`;
export const SubTitle = styled.p`
  font-size: 14px;
  color: #666666;
  margin: 0 0 24px 0;
`;

export const AppearanceGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 36px;
  margin-top: 36px;
`;

export const AppearanceCard = styled.div`
  background: #ffffff;
  /* border: 1px solid #e0e0e0; */
  /* border-radius: 8px; */
  /* box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05); */
`;

export const AppearanceCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

export const AppearanceLeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 35px;
  flex: 1;
`;

export const AppearanceBadgesRow = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const AppearanceInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
`;

export const AppearanceName = styled.h3`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #000000;
`;

export const AppearanceActions = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;

export const IconButtons = styled.button`
  background: none;
  border: none;
  padding: 6px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;
  color: #666;

  &:hover {
    background-color: #f5f5f5;
    color: #000;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  svg {
    cursor: pointer;
    width: 20px;
    height: 20px;
  }
`;

export const StatusBadge = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  background-color: ${(props) => props.backgroundColor || "#e0e0e0"};
  color: #ffffff;
  text-transform: capitalize;
`;

export const AppearanceDetails = styled.div`
  margin-top: 16px;
`;

export const DetailRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  font-size: 14px;
  color: #666666;
`;

export const DetailLabel = styled.span`
  font-weight: 600;
  margin-right: 8px;
  color: #000000;
`;

export const ImageStatusList = styled.div`
  display: flex;
  gap: 25px;
  margin-top: 16px;
  flex-wrap: wrap;
  position: relative;
`;

export const ImageThumbnail = styled.div`
  width: 120px;
  height: 120px;
  /* border-radius: 4px; */
  border: 1px solid #000;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.2s ease;
  box-sizing: content-box;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &:hover {
    z-index: 10;
   box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    border-radius: 6px; */
  }

  &:hover .image-actions {
    display: flex;
  }

  [class^="StyledLoader"] {
    width: 1.5rem;
    height: 1.5rem;
  }
`;

export const ImageActions = styled.div`
  position: absolute;
  top: 2px;
  right: 2px;
  display: none;
  gap: 2px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 3px;
  padding: 2px;
`;

export const ImageDeleteButton = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  // padding: 2px;
`;

const ImageStatusIcon = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 1;
  border-radius: 2px;
  background-color: ${({ status }) => IMAGE_STATUS_ICON_BG_COLORS[status] || "#008331"};

  svg {
    width: 16px;
    height: 16px;
    display: block;
  }
`;

export const ImageStatusIconList = styled(ImageStatusIcon)`
  width: 36px;
  height: 36px;
`;

export const ImageStatusIconAdd = styled(ImageStatusIcon)`
  width: 24px;
  height: 24px;
`;

export const ImagePlaceholder = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 4px;
  background-color: #f9fafb;
  border: 1px dashed #d1d5db;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #9ca3af;
  font-size: 10px;
`;

export const ViewStreamsRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  margin-top: 12px;
  align-items: center;
`;

export const ViewStreamsLink = styled.div`
  text-decoration: underline;
  display: inline-block;
  cursor: pointer;
`;

export const SitesSection = styled.div`
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  width: 78vw;
  height: 130px;
  opacity: 1;
  gap: 20px;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  padding: 12px;
`;

export const SitesLabel = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
`;

export const SitesList = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px 16px;
  margin-top: 12px;
`;

export const SiteTag = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 4px;
  background-color: transparent;
  border: none;
  font-size: 12px;
  color: #374151;

  input[type="checkbox"] {
    margin-right: 6px;
    cursor: pointer;
    accent-color: #000000;
  }

  label {
    cursor: pointer;
    user-select: none;
  }
`;

export const ImageStatusBadge = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 12px;
  width: fit-content;
  height: 20px;
  font-size: 12px;
  font-weight: 500;
  background-color: ${({ status, isError }) => (isError ? STATUS_BADGE_BG_COLORS.errors : STATUS_BADGE_BG_COLORS[status] || "#f3f4f6")};
  color: ${({ status, isError }) => (isError ? STATUS_BADGE_TEXT_COLORS.errors : STATUS_BADGE_TEXT_COLORS[status] || "#374151")};
  text-transform: capitalize;

  &.deploy-modal-badge {
    background-color: ${BADGE_COLORS.BG_ACTIVE};
    color: ${BADGE_COLORS.TEXT_WHITE};
    margin-left: 8px;
  }
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
`;

export const EmptyStateTitle = styled.h3`
  font-size: 20px;
  font-weight: 600;
  color: #000000;
  margin-bottom: 8px;
`;

export const EmptyStateDescription = styled.p`
  font-size: 14px;
  color: #666666;
  margin: 0;
`;

export const LoaderContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 60px 20px;
  min-height: 600px;
`;

export const ImageEmptyPlaceholder = styled.div`
  width: 120px;
  height: 120px;
  border: 1px dashed #cccccc;
  background: #f5f5f5;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  font-size: 12px;
  justify-content: center;
`;

// New styles for the Image Preview Modal
export const ModalImageWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 561px;
  height: 454px;
  gap: 10px;
`;

export const LargeImage = styled.img`
  width: 441px;
  height: 454px;
  object-fit: contain;
`;

export const ModalNavButton = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: #cccccc;
  color: white;
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  transition: background-color 0.2s;
  padding: 0;

  svg {
    width: 20px;
    height: 20px;
    stroke: black;
    fill: none;
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
  }

  ${({ direction }) => (direction === "left" ? "left: 10px;" : "right: 10px;")}
`;

export const CarouselWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  /* Override VDS Carousel navigation button positioning */
  [id*="pagination-control"],
  button[id*="left-pagination-control"],
  button[id*="right-pagination-control"] {
    position: absolute !important;
    z-index: 1000 !important;
    background-color: rgba(255, 255, 255, 0.9) !important;
    border: 1px solid #e0e0e0 !important;
    border-radius: 50% !important;
    width: 40px !important;
    height: 40px !important;
    min-width: 40px !important;
    min-height: 40px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
    transition: all 0.2s ease !important;

    &:hover {
      background-color: rgba(255, 255, 255, 1) !important;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
    }
  }

  /* Position left button on the left side */
  button[id*="left-pagination-control"] {
    top: 50%;
    margin-top: 200px;
  }

  /* Position right button on the right side */
  button[id*="right-pagination-control"] {
    bottom: 50%;
    margin-bottom: 200px;
  }

  /* Style the SVG icons to be black */
  button[id*="pagination-control"] svg,
  button[id*="pagination-control"] polygon {
    fill: #000000 !important;
    color: #000000 !important;
  }

  /* Center the carousel content */
  [class*="carousel-wrapper"],
  [class*="carousel-content"],
  [class*="carousel-track"] {
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
  }
`;

// Inline-style replacements
export const SitesIntroText = styled(Body)`
  font-weight: 400 !important;
  font-size: 16px !important;
  line-height: 20px !important;
  letter-spacing: 0.5px !important;
`;

export const ModalHeader = styled.div`
  margin-bottom: 20px;
`;

export const DeployModalContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`;

export const DeployModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const DeployModalInfo = styled.div``;

export const SitesAccordionContainer = styled.div`
  margin: 20px 0 0 10px;

  & [class^="StyledTypography-VDS"] {
    margin-bottom: 16px;
  }
`;

export const SitesAccordionScrollContainer = styled.div``;

export const AccordionSelectedCount = styled.span`
  font-size: 16px;
  color: #6f7171;
`;

export const AccordionHeaderContent = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const BadgeWrapper = styled.span`
  display: inline-flex;
  gap: 6px;
  margin-left: 12px;
  vertical-align: middle;
`;

export const CheckboxContainer = styled.div`
  margin-bottom: 10px;

  & #ccd-checkboxes [class^="LabelWrapper-VDS__"] {
    font-weight: 400;
  }
`;

export const LoaderWrapper = styled.div`
  width: 100%;
`;

export const NotificationContainer = styled.div`
  margin: 0 0 20px;
`;

export const SubtitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const LegendContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #374151;
`;

export const LegendIconBadge = styled.span`
  width: 20px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 2px;
  background-color: ${({ color }) => color};
`;

export const ConfirmDeployModalContent = styled.div`
  padding: 20px 0 0;
`;

export const ConfirmDeployModalActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`;

export const ModalCloseButton = styled.div`
  cursor: pointer;
  position: absolute;
  right: 25px;
  top: 25px;
`;

export const ModalTitleRow = styled.span`
  display: flex;
  align-items: baseline;
  gap: 8px;
`;

export const ModalTitleInfoIcon = styled.span`
  cursor: pointer;
  display: inline-flex;
`;

export const LockedWarningBanner = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 4px 0;
  background: #f0f0f0;
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 14px;
  color: #000000;
`;

export const OfflineDeviceNote = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  background: #f0f0f0;
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 12px;
  color: #000000;
  margin-top: 8px;
  width: fit-content;
`;

export const SelectedCountText = styled.span`
  color: ${({ $hasSelected }) => ($hasSelected ? "#026f28" : "inherit")};
`;

export const TabsWrapper = styled.div`
  margin-top: 24px;
`;

export const DeploySelectedCountSpan = styled.span`
  margin-left: 8px;
  color: ${BADGE_COLORS.TEXT_MUTED};
  font-size: 14px;
`;

export const ViewOnlySiteRow = styled(CheckboxContainer)`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const SiteIconPlaceholder = styled.span`
  width: 16px;

  display: ${({ hidden }) => (hidden ? "none" : "inline-block")};
`;

export const DeploymentLockLink = styled.span`
  text-decoration: underline;
  cursor: pointer;
`;
